const csrfElement = document.querySelector('meta[name="csrf-token"]');
const csrf = csrfElement?.getAttribute('content') || null;

const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
  'x-csrf-token': csrf,
};
const defaultCredentials = 'same-origin';

const handleResponse = async (res) => {
  if (res.status === 204) { // No Content
    return [];
  }

  let body;

  try {
    body = await res.clone().json();
  } catch {
    try {
      body = await res.clone().text();
    } catch {
      body = res.body;
    }
  }

  if (!res.ok) {
    throw body;
  }

  return body;
};

const executeRequest = async (req, options = {}) => {
  try {
    const res = await fetch(req, {
      credentials: options.credentials || defaultCredentials,
      headers: options.headers || defaultHeaders,
    });

    return await handleResponse(res);
  } catch (err) {
    throw err;
  }
};

const request = async (url, method, options = {}) => {
  const config = {
    method,
    body: JSON.stringify(options.data),
    credentials: 'include',
  };
  if (options.redirect === false) config.redirect = 'manual';

  let urlData = url;
  if (options.query) {
    const query = new URLSearchParams(options.query);
    urlData += urlData.includes('?') ? '&' : '?';
    urlData += query.toString();
  }
  const req = new Request(urlData, config);
  return executeRequest(req, options);
};

const uploadRequest = async (url, options = {}) => {
  const formData = new FormData();

  if (options.data) {
    Object.entries(options.data).forEach(([key, value]) => {
      if (value != null) {
        formData.append(key, value);
      }
    });
  }

  try {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrf,
      },
      body: formData,
    });

    return await handleResponse(res);
  } catch (err) {
    throw err;
  }
};

const putRequest = async (url, options = {}) => request(url, 'PUT', options);

const postRequest = async (url, options = {}) => request(url, 'POST', options);

const getRequest = async (url, options = {}) => request(url, 'GET', options);

const patchRequest = async (url, options = {}) => request(url, 'PATCH', options);

const deleteRequest = async (url, options = {}) => request(url, 'DELETE', options);

export {
  request, putRequest, postRequest, getRequest, patchRequest, deleteRequest, uploadRequest,
};
